import React, { useContext, useState } from 'react';
import { ActionModal } from '../../../../components/Modal';
import { TranslationKey } from '../../../../../types/translation/TranslationKey';
import { t } from '../../../../../types/translation/Translator';
import { CompanyConnection } from '../../../../../types/companyConnection/companyConnection';
import { CompanyContext } from '../../../../../context/CompanyContext';
import useMutation from '../../../../../hooks/useMutation';
import {
  CompanyConnectionMutations,
  CreateCompanyConnectionResponse,
  CreateCompanyConnectionVariables,
} from '../../../../../graphql/companyConnection.graphql';
import { CompanyConnectionContext } from '../../../../../context/CompanyConnectionContext';
import { Button, ButtonVariant } from '../../../../components/Button';
import CompanyConnectionInfoPane from '../Common/CompanyConnectionInfoPane';

interface CreateCompanyConnectionModalProps {
  open: boolean;
  setOpen: (open: boolean) => void;
}

export default function CreateCompanyConnectionModal({ open, setOpen }: CreateCompanyConnectionModalProps) {
  const { currentCompany } = useContext(CompanyContext);
  const { companyConnections, setCompanyConnections } = useContext(CompanyConnectionContext);

  const [item, setItem] = useState<CompanyConnection>(
    new CompanyConnection({ companyId: currentCompany.id, parentId: currentCompany.id }),
  );

  const [create, { loading }] = useMutation<CreateCompanyConnectionResponse, CreateCompanyConnectionVariables>(
    CompanyConnectionMutations.create,
    {
      onCompleted: response => {
        const connection = response.createCompanyConnection[0];
        setCompanyConnections(new Map(companyConnections).set(connection.id, new CompanyConnection(connection)));
        setOpen(false);
      },
    },
  );

  const valid = () => {
    return item.companyId && item.types.length;
  };

  const handleCreate = async () => {
    await create({ variables: { companyConnections: [item.forCreate()] } });
  };

  const footer = (
    <>
      <div className='grid grid-cols-2'>
        <div>
          <Button
            text={t(TranslationKey.cancel).singular.label}
            variant={ButtonVariant.secondary}
            onClick={() => setOpen(false)}
          />
        </div>
        <div className='flex justify-end'>
          <Button
            loading={loading}
            text={t(TranslationKey.create).singular.label}
            onClick={handleCreate}
            disabled={!valid()}
          />
        </div>
      </div>
    </>
  );

  return (
    <ActionModal open={open} setOpen={setOpen} title={t(TranslationKey.linkCompany).plural.upper} footer={footer}>
      <CompanyConnectionInfoPane item={item} setItem={setItem} loading={loading} />
    </ActionModal>
  );
}
